import { render, staticRenderFns } from "./FourthSection.vue?vue&type=template&id=f2ff015a&scoped=true&"
import script from "./FourthSection.vue?vue&type=script&lang=js&"
export * from "./FourthSection.vue?vue&type=script&lang=js&"
import style0 from "./FourthSection.vue?vue&type=style&index=0&id=f2ff015a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ff015a",
  null
  
)

export default component.exports